import Loader from "@/src/components/atom/Loader";
import MainPageNavigation from "@/src/components/organism/MainPageNavigation";
import { lazy, Suspense, useEffect } from "react";
import { MainPageWrapper } from "./styles/mainPage.styles";
const HeroSection = lazy(() => import("./sections/HeroSection"));
const FeaturesSection = lazy(() => import("./sections/FeaturesSection"));
const EcoyaSnapSection = lazy(() => import("./sections/EcoyaSnapSection"));
const CostReductionSection = lazy(
  () => import("./sections/CostReductionSection"),
);
const ClientsSection = lazy(() => import("./sections/ClientsSection"));
const PricingSection = lazy(() => import("./sections/PricingSection"));
const PartnersSection = lazy(() => import("./sections/PartnersSection"));
const FAQSection = lazy(() => import("./sections/FAQSection"));
const ContactSection = lazy(() => import("./sections/ContactSection"));
const FooterSection = lazy(
  () => import("@/src/components/organism/FooterSection"),
);

// Feature flags for sections (aligned with Figma design)
const SHOW_CLIENTS_SECTION = false;
const SHOW_PRICING_SECTION = false;
const SHOW_PARTNERS_SECTION = false;

const MainPage = () => {
  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <MainPageWrapper>
      {/* Navigation - Full width */}
      <MainPageNavigation />

      {/* Hero Section */}
      <Suspense fallback={<Loader />}>
        <HeroSection />
      </Suspense>

      {/* Features Section */}
      <Suspense fallback={<Loader />}>
        <FeaturesSection />
      </Suspense>

      {/* Ecoya Snap Section */}
      <Suspense fallback={<Loader />}>
        <EcoyaSnapSection />
      </Suspense>

      {/* Cost Reduction Section */}
      <Suspense fallback={<Loader />}>
        <CostReductionSection />
      </Suspense>

      {/* Clients Section - Hidden in current design */}
      {SHOW_CLIENTS_SECTION && (
        <Suspense fallback={<Loader />}>
          <ClientsSection />
        </Suspense>
      )}

      {/* Pricing Section - Hidden in current design */}
      {SHOW_PRICING_SECTION && (
        <Suspense fallback={<Loader />}>
          <PricingSection />
        </Suspense>
      )}

      {/* Partners Section - Hidden in current design */}
      {SHOW_PARTNERS_SECTION && (
        <Suspense fallback={<Loader />}>
          <PartnersSection />
        </Suspense>
      )}

      {/* FAQ Section */}
      <Suspense fallback={<Loader />}>
        <FAQSection />
      </Suspense>

      {/* Contact Section */}
      <Suspense fallback={<Loader />}>
        <ContactSection />
      </Suspense>

      {/* Footer - Full width */}
      <Suspense fallback={<Loader />}>
        <FooterSection />
      </Suspense>
    </MainPageWrapper>
  );
};

export default MainPage;
